import type { FC } from 'react'
import { Button } from '#components/Button'
import { configureReactScan } from '#store/debugConfiguration'
import { useSharedAppDispatch, useSharedAppSelector } from '#store/sharedBaseStore'

export const ReactScan: FC = () => {
  const dispatch = useSharedAppDispatch()
  const enabled = useSharedAppSelector((x) => x.debug.reactScan.enabled)
  if (enabled) {
    return undefined
  }
  return (
    <Button
      size="xs"
      onClick={() => {
        dispatch(
          configureReactScan({
            enabled: true,
            showToolbar: true,
            animationSpeed: 'slow',
            trackUnnecessaryRenders: true,
          }),
        )
      }}
    >
      Enable React Scan
    </Button>
  )
}
